module.exports = __webpack_public_path__ + "img/icon-calendar-purple.7c320816.svg";